import React from 'react';
import PropTypes from 'prop-types';
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Typography,
} from '@mui/material';

export const ATTENDANCE_VISIBILITY_OPTIONS = [
    {
        value: 'PRIVATE',
        shortLabel: 'Invite-only',
        label: 'Private — only people I send a private invite link to',
        detailsLine: 'Invite-only (private link)',
    },
    {
        value: 'VERIFIED',
        shortLabel: 'Verified attendees',
        label: 'Verified — open to attendees verified by at least one Porchlight host',
        detailsLine: 'Open to verified attendees',
    },
    {
        value: 'PUBLIC',
        shortLabel: 'Public',
        label: 'Public — listed for anyone on the upcoming concerts page',
        detailsLine: 'Listed publicly',
    },
];

export const normalizeAttendanceVisibility = (value) => {
    const visibility = String(value || 'PRIVATE').toUpperCase();
    if (
        visibility === 'PUBLIC' ||
        visibility === 'VERIFIED' ||
        visibility === 'NONE'
    ) {
        return visibility;
    }
    return 'PRIVATE';
};

export const attendanceVisibilityDetailsLine = (value) => {
    const visibility = normalizeAttendanceVisibility(value);
    const option = ATTENDANCE_VISIBILITY_OPTIONS.find(
        (item) => item.value === visibility
    );
    return option ? option.detailsLine : 'Invite-only (private link)';
};

const AttendanceVisibilityPicker = ({
    value,
    onChange,
    name = 'attendanceVisibility',
    showLegend = true,
    legend,
    helperText,
}) => {
    const current = normalizeAttendanceVisibility(value);
    const pickerValue = current === 'NONE' ? 'PRIVATE' : current;

    return (
        <FormControl
            component="fieldset"
            sx={{ width: '100%', textAlign: 'left' }}
        >
            {showLegend ? (
                <FormLabel component="legend">
                    {legend || 'Who should be able to see this concert?'}
                </FormLabel>
            ) : null}
            {showLegend ? (
                <Typography
                    component="small"
                    sx={{ display: 'block', mb: 1, opacity: 0.85 }}
                >
                    {helperText ||
                        'You can change this later. Your street address is only shared in an email to the attendee when they RSVP to your event.'}
                </Typography>
            ) : null}
            <RadioGroup
                id={name}
                name={name}
                value={pickerValue}
                onChange={onChange}
            >
                {ATTENDANCE_VISIBILITY_OPTIONS.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

AttendanceVisibilityPicker.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    showLegend: PropTypes.bool,
    legend: PropTypes.node,
    helperText: PropTypes.node,
};

export default AttendanceVisibilityPicker;
